import { render, staticRenderFns } from "./BtnDiaporama.vue?vue&type=template&id=28c337f3&scoped=true&"
import script from "./BtnDiaporama.vue?vue&type=script&lang=js&"
export * from "./BtnDiaporama.vue?vue&type=script&lang=js&"
import style0 from "./BtnDiaporama.vue?vue&type=style&index=0&id=28c337f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c337f3",
  null
  
)

export default component.exports